export const columns = [
    {
        title:'日期',
        dataIndex:"date",
        key:"date"
    },
    {
        title:'人数',
        dataIndex:"peopleNumber",
        key:"peopleNumber"
    },
    {
        title:'次数',
        dataIndex:"timeNumber",
        key:"timeNumber",
    },
    {
        title:'费用',
        dataIndex:"cost",
        key:"cost",
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime",
        slots:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]